import type { CartConfig } from '#root/types/config/components/cart'
import type { RecursivePartial } from '#root/types/utils'

export default {
  allowRemovalUndo: true,
  brandClasses: {
    editItemCta: 'mt-4 flex items-center gap-2 underlined <lg:hidden',
    eyebrow: 'eyebrow c-grey-20',
    pricing: 'text-sm',
    pricingCurrent: 'fw-bold',
    promoTooltip: 'eyebrow'
  },
  showItemLevelPromocode: true,
  showOrderLevelPromocodeOnItem: true,
  thumbnails: {
    align: 'north_west',
    height: { sm: 118 },
    width: { sm: 94 }
  },
  variantOrder: ['color', 'size', 'width', 'length']
} satisfies RecursivePartial<CartConfig['item']>
